'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _forgotPassword = require('./forgot-password.component');

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.auth.forgotPassword', [_angularUiRouter2.default]).component('forgotPassword', _forgotPassword2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('forgotPassword', {
    parent: 'auth',
    url: '/forgot-password',
    params: {
      userName: null
    },
    component: 'forgotPassword',
    resolve: {
      userName: function userName($stateParams) {
        return $stateParams.userName;
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/auth/forgot-password/forgot-password.module.js